import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'primereact/button';
import UserInfo from '../../../shared/UserInfo/UserInfo';
import { ImplementationFor, arraySort,  } from '../../../shared/utility';
import { baseLogoImg, lightningHandLogo, shamalAzzourLogo, ministryLogo, newKuwaitLogo, boldArabicFont, securityStamp, securityPositionFalah, securitySignatureFalah, securityPositionAnezi, securitySignatureAnezi, securityPositionJaseer, securitySignatureJaseer } from '../../../shared/fontsAndBitImages';
import * as actions from '../../../store/actions/index';
import Messages from '../../../shared/UI/Messages/Messages';
import { Toast } from 'primereact/toast';
import axios from '../../../axios-url';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { DROPDOWN_CONFIG } from '../../../shared/Config';
import moment from 'moment';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Fieldset } from 'primereact/fieldset';
import AZNLogo from '../../../assets/images/AZN LOGO .jpg';
import Attachments from '../../../shared/UI/Attachments/Attachments';
import jsPDF from "jspdf";
import 'jspdf-autotable';
import lodash from 'lodash';


const Inputs = ({ field, metaData, onInputChange, type, ...props }) => {
    const Component = ImplementationFor[parseInt(field.fieldType)] || false;

    return Component && <Component
        {...field}
        {...props}
        name={field.fieldName}
        label={field.fieldDescription}
        placeholder={field.fieldDescription}
        onInputChange={onInputChange}
        metaData={Object.assign({}, metaData, { "TA Request Number": props.TARequestNumber })}
    /> || null;

}

const MATERIAL_PASS_VEHICLE_ID = 'E8A2F12B-6E40-4997-9EB9-B73A8948026D';

class AddMaterialPassVehicle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:'',
            month:'',
            year:'',
            loading: true,
            process: [],
            initialData: {},
            progressStarted: false,
            payslipGenerated: false,
            stageSequence: 0,
            month: false,
            year: false,
            requestDate: moment(),
            requestedFor: false,
            DynamicSupervisor: false,
            dynamicSupervisorDisplay: false,
            DynamicSupervisorsList: [],
            requestId: false,
            popupType: 'submit',
            requestattachments:[],
        }
    }

    handleChange = (e, el) => {
        e.preventDefault();
        const { name, value } = e.target;

        if(name == '002001000015' && value.length > 29){//limiting number of characters allowed in reason for visit
            this.growl.show({ severity: 'error', summary: null, detail: 'Maximum 30 Characters allowed in reason' });
            return;
        }

        this.setState({
            process: this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.map(field => Object.assign({}, { ...field }, { fieldValue:  field.fieldName === name ? value : field.fieldValue })) }))
        });
        this.setState({ payslipGenerated: false})


    }

    handleAttachment = (data, type) => {
        let index = 0;
        let attachmentData = data.map((el) => {
            index++
            return{
                Requestattachmentid: '00000000-0000-0000-0000-000000000000' ,
                Requestid :'00000000-0000-0000-0000-000000000000',
                SiNo: index ,
                UploadPath:el.filePath ,
                FileName:el.fileName ,
                Extension :el.fileExtension,
                Createdby: this.props.loggedUserDetail.empID ,
                Createddate: moment().format('MM/DD/YYYY') ,
                Updatedby: this.props.loggedUserDetail.empID ,
                Updateddate: moment().format('MM/DD/YYYY') ,
                CompanyId: this.props.loggedUserDetail.CompanyId ,
                Stagenum: 0 ,
            }
        });
        this.setState({requestattachments:attachmentData});
    }

    initialize = (process, type, field) => {
        const { tableLists, location = {}} = this.props;
        const { stageSequence } = this.state;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;         
        const pageType = this.props.match.params.type;
        const pendingWith = location && location.state && location.state.pendingWith


        let count = 1;
        let sequence = 1;
        if (type === 'progress' || type === 'add' || type === 'edit') {
            this.setState({ process: [], loading: true });

            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                return Object.assign({}, { ...stage }, {
                    stage_Field: stageField.reduce((a, el) => {
                        const startIndex = el.fieldName.substring(0, 10);
                        if (type === 'add' && el.parentFieldId === '000' && el.fieldType != '9') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                        } else if (type === 'add' && el.fieldType === '9') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            const fields = stageField.filter(_ => _.parentFieldId === el.fieldName);
                            const lastItem = a[a.length - 1];
                            fields.map((subField) => {
                                a.push(Object.assign({}, { ...subField }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName, childRowNmbr: '0' }));
                            })
                        } else if (type === 'edit') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stage_FieldsList: [], disabled: (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            const lastItem = a[a.length - 1];
                            if (el.stage_FieldsList && el.stage_FieldsList.length > 0) {
                                el.stage_FieldsList.map((subField, subIndex) => {
                                    if (subIndex != 0) {
                                        subField.stage_FieldsListc2.map(c2 => {
                                            a.push(Object.assign({}, { ...c2 }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, disabled: (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName }));
                                        })
                                    }
                                })
                            }
                        }
                        return a;
                    }, [])
                })
            });

            setTimeout(() => this.setState({ loading: false, process: InitialValues }), 3000);
        } else {

            this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
        }

    }
    generatePayslip = (type) => {
        let process= this.state.process;
        const { containerData, location = {},} = this.props;
        const { state = {} } = location;
        let requestId = state.requestId

        this.setState({ loading: true });
        axios.get('/master/api/Employee/GetFinalapprover?RequestId='+requestId)
        .then((response) => {
            if(response.status === 200){
                let empId = response.data.toUpperCase();
                this.handlePayslipInPdf(type, empId);
            }
        }).catch((error) => {
            this.growl.show({ severity: 'error', summary: null, detail: 'Final Approver API Error, please try again' });
            this.setState({ loading: false });
        })
    }

    handlePayslipInPdf = (type, empId) => {
        this.setState({ loading: true });
            var doc = new jsPDF('p', 'mm', 'letter');//jsPDF(orientation, unit, format)
            let text;

            let process= this.state.process;
            const { containerData, location = {},} = this.props;
            const { state = {} } = location;
            let requestNumber = state.requestNum


            let requestedFor = "";  
            let requestDate = "";
            let requesterName =  "";
            let driverName =  "";
            let nationality = "";
            let vehicleNo = "";
            let colour =   "";
            let model = "";
            let department = '';
            let reasonFor = "";
            let material = "";
            let fromLocation = "";
            let toLocation = '';
            let companyName ='';
            let equipment = '';
            let licenseNo = '';

            process.map((stage, stageIndex) => {
                stage.stage_Field.map(el => {
                    if (el.fieldId === "3c308c20-2edf-4fde-a5bb-e6926de55f8b" && stageIndex === 0) {
                        requestedFor = el.fieldValue || '';
                    }
                    if (el.fieldId === "e9de0fdf-a89d-402d-9123-99a9ea4767de" && stageIndex === 0) {
                        vehicleNo = el.fieldValue || '';
                    }
                    if (el.fieldId === "d57ffb59-31c1-474c-8440-9a007d05a189" && stageIndex === 0) {
                        licenseNo = el.fieldValue || '';
                    }
                    if (el.fieldId === "48f4fc2f-7d4e-48f6-8334-8443dfb7c898" && stageIndex === 0) {
                        material = el.fieldValue || '';
                    }
                    if (el.fieldId === "49916756-4246-4bae-8515-eb5045a0e4aa" && stageIndex === 0) {
                        model = el.fieldValue || '';
                    }
                    if (el.fieldId === "907cc058-17bb-4711-9de6-5eb4c9e2ae96" && stageIndex === 0) {
                        requestDate = moment(el.fieldValue).format('MM/DD/YYYY');
                    }
                    if (el.fieldId === "99f87174-456f-4012-ae40-76ecc926ff17" && stageIndex === 0) {
                        driverName = el.fieldValue || '';
                    }
                    if (el.fieldId === "f32eb803-9817-42b7-a8b2-ccf3365b4abd" && stageIndex === 0) {
                        requesterName = el.fieldValue || '';
                    }
                    if (el.fieldId === "d57ffb59-31c1-474c-8440-9a007d05a199" && stageIndex === 0) {
                        colour = el.fieldValue || '';
                    }
                    if (el.fieldId === "37f3e904-f1fb-4bc5-b0eb-84f2d500f731" && stageIndex === 0) {
                        nationality = el.fieldValue || '';
                    }
                    if (el.fieldId === "a5f429f0-1552-4c3b-9c78-5491d12ddee8" && stageIndex === 0) {
                        companyName = el.fieldValue || '';
                    }
                    if (el.fieldId === "8a953c28-93a7-43ee-85a4-dc25e9a214d3" && stageIndex === 0) {
                        reasonFor = el.fieldValue || '';
                    }
                    if (el.fieldId === "b887fe68-4459-48db-a79a-a59b4d50c86e" && stageIndex === 0) {
                        department = el.fieldValue || '';
                    }
                    if (el.fieldId === "d57ffb59-31c1-474c-8440-9a007d05a199" && stageIndex === 0) {
                        equipment = el.fieldValue || '';
                    }
                    if (el.fieldId === "84a09b6a-bf37-46ce-bdb8-85dd4625855e" && stageIndex === 0) {
                        fromLocation = el.fieldValue || '';
                    }
                    if (el.fieldId === "c6f267e3-3e3a-42ad-9f2f-b310993afb92" && stageIndex === 0) {
                        toLocation = el.fieldValue || '';
                    }
                })
            });

            function drawDottedLine(doc, x1, y1, x2, y2, dashLength, gapLength) {
                let dashX = (x2 - x1);
                let dashY = (y2 - y1);
                let dashLengthAdjusted = Math.sqrt(dashX * dashX + dashY * dashY);
                let dashCount = Math.floor(dashLengthAdjusted / (dashLength + gapLength));
              
                // Calculate direction of the line
                let angle = Math.atan2(dashY, dashX);
                let dashXStep = Math.cos(angle) * (dashLength + gapLength);
                let dashYStep = Math.sin(angle) * (dashLength + gapLength);
              
                for (let i = 0; i < dashCount; i++) {
                  let startX = x1 + dashXStep * i;
                  let startY = y1 + dashYStep * i;
              
                  // Draw dash segment
                  doc.line(startX, startY, startX + Math.cos(angle) * dashLength, startY + Math.sin(angle) * dashLength);
                }
              }
            const denimBlue = [21, 96, 189];

// Add a border for the entire Gate Pass
            doc.setLineWidth(1);
            doc.rect(10, 10, 190, 200); // x, y, width, height
            doc.line(10, 210, 200, 210);

            let img = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATsAAACgCAMAAABE1DvBAAAAyVBMVEX///8ST43S1NUAAAAARIgAR4mHm7oAQIYjHyAASosAPYQASYrV19eossHP09UJAAAZFBXFx8geGhuTk5Tm5uYwLC2mts1JR0icm5wkWZOarMaAmLlkYmKtrKzx8fE5Zprk6vFOc6LQ2OSJiot3kbQTDQ/29vbf39+4t7dsia85Njeko6MnIySxsLAAOYLV3edafKdZV1g/PD3Dzt2su9B5d3hPTU55d3cAL36Mi4tfXV0ADjap
            s8JUd6QrXZWPpMC5x9lveosAHT6oHeTpAAALaElEQVR4nO2dfUPiuhLGC2lpCz23aQFBxQrUtiAKAiLr3rvqvd//Q92ZScKL6549sru+wDx/uEmaDubnJJMUmLUsFovFYrFYLBaLxWKxWCwWi8VisVgsFovFYrFYLBaLxWKxWCwWi8VisVgsFot1SEqCoKGLRUAqkvVVaMpVKVcXTedks1Sse6vCummvNRVC6OKl0ArbuiWBylIVA3NRNYyEqH9noGkahcje5rd/VzWE54mBKrdiL0Q40hMj1TIK4apyvEB4MXH1wjuonoUacLJhYBZ7grxRxs03Hc
            X7qB16cdxS5VYcDsrlctQBeKqlGQPOMyoGIr7DST2Ai+UNdpsGgJ2cYuEw2Hnx1V0s1OrUipXXWJl2n7KIp1l8SW2BUFisehZeb7DbNADslA8eBLtIZOkgzFKqrNiZqbfMRDGVggLAil2aYYNht2UA/S6W1oGw6wCZXMQhVTS7pB7GHtbhwpV1HWYLrMCcbQ1AyzBDhobdQsIMFnqOz+TlUiLHQ2BHdBAgLfYQK1SYlSLCOmCrQxcVLXSsCDO1uGl22wZm0sPuxUGwG4VZG+ed4kFxVnpec2mWL/TDpaRoAewkkZVylq/YbRuYydg6E/HsINhdxtkI5mHm0WK
            PcTZaiPhSrXqF8JrRYHCvooVe7/KiI7OvK3bagFQGkB0SHzT3nx34kpfhls2jxV6td2moQ0aaeTiH8WewESssmsSK3TMDxA6QX13tP7tlphY4EdNir2PFLFYjN5MU/l0+Y5dodhsGMNwQO2K+9+xwXW8kKKA2WLGDo0YIR6uBkB26GJCjQZydWnmeJ2mG2xDFbmXgjgwodhZsqPee3TXQMSVc7M3+ro1IrKmOtnBixWhhzmQwh/HERuyeG9DsBmL/2cHRXdPJRQiL/UzovTEUWg1o0v0GQlwBu5AE9O6h7UyINj480AYs6B1gnSpTmMRvOpI3Vz46G5nyYDQq
            W9ejkTr3N+AKtAzMVagmyegMdT2I6BFVADfk7S0DERqgCvZ9q1GwWCwWi/X7Nf9i77/Gf4Zd3y3tvxxmt7OY3e76veyKSOsv570H9gbyzWijxs/R/ET11dvL4t/vPa430Xq8zejneP5GSVMsrg/U70Yt8/GE3dTMBkUQlEnBf+z3HtgbyP+XGW5Q1EW6O7q6GGhLaOyvw2C3GnC5SMXuHw8Si6J8wOzKgVzsii4Q18Fhs1vs/NGqSEQHzq4ufk7ph+zKb8vOr/l/U/1Fa//sno/BzifZVVvXVk2O6/rrDih1g+v0ht9K5vTiuz5Uj6u1LYOl7Rt9bRh+OqX164
            Ac9+Fm2PNfexb6EOzsI20luYX7bCgc++e6Ke+fOyXnZP1K2KVWeqIyXsP7exOqdodVbdHNLWsOLNz+xu9o96BLtXYKPxETGq0g7fFjsmntk7LDsZXsfJMd6Jtvb7PbuPgNBm9frC8qeLUhVo5/yM46cjU7oGVPtqx9QnaTo6PbLhh6dFbs8pOjoznxRHbQAXU7rJV8aMwfhwg0B5I9/PdkWEEGj/TCVUJ2YpdqlVuy0cU7nTU762HFjvrOT4f093vVr/1h2J2MbfvLHJ/ArNl9se3qDQ4U2d2O1RPHGnXvQsE+tnD0VUA+ce2aM8bhk0G4AEbyMXggmBjqZ7H+B
            rvJWLMjF72pOo6Lzlx5jeN9GHZHcIdzQU62YocTEB/OnhO7ag0Fy3sVOtzgIO3Hp4sHmsAPtOqPu+i30A7dH7u6E1mlZ2Kb7KwLR7HDWa1mul05Gj685tf+MOxO4E//5emZ32lvIL+bD5V8/wGaVEx0bIgjFVoljZ25reAeP5qniC+wg9mdOzaxw8jUU3Hddu1XbVQ+DLv5aeURF7fN9e60UsFpqNY7I9uHaZxUt25+Ui/nIBa3hB1gTloULV5kh0vj7Rdih/Mee/VuUL1PyU4Ldg8/ibPErrvN7la9XI3mfMmFv0HFHvcpWrzI7gRd9/wRu2l2rgq2k9fs8T4Yuy
            dcrbbZdXs2LWBP38gzbkr+N70UYiTwldPqKfyoRo9geoiG3PMlduNb6FmhOGupzYxi96r3Cj4Mu1sYbcnF29ZzFpoeHDxXqFhhTgfoKrQwORdH5w46WzImO+hwTzYSNMJo8RI7GzfPXYrSsC++gG3PzRD3PJ+T3ZFrTkhrdmOzdBO7lUnclFRwkBhXT2jWDfGijz40rGGrUb/6Mju1NaFYAR7YHeOBFvcyn5Td6o7tPcqK3dGXKsmlqWn1xi4u9rA7QW+zbsZ29Rig5S5NaYgylQp2O/4Bu9K4r9iVcOmbV113fD7ZW3Z5VwmGV8XFafIEqKxbHCz+At0ngvGt5j7h/
            HZA6IBg9mV2NPORnU1TfE7WPj8760V2RhhiHXMEVUweuuYizF1817SnlkMIBlb1R+yIGZ5nq+v18fZVDwM+BLtaZTJZn4acfn9yXHqY9OcrI87ppG9Ee7nqRT+38v6Fouu7lT6u/Sclp+QP4UYDfdKf9CAMTCb0l/HPJ3A3dJic4ou58/5kiJDt46MuWJucHL/uKdRvZPcLz41rrrtxkHRdl35u2HDclfRWzh2Pq66zvl4dV9XTP3/jRmVp1aIKvnkxWz8bhFK1umntH2qbXbozu4ZoH/Yz92I625WdNZsd9PtkQSRGP4f0A0UiLQ6XXRDMwp3RWVYqlmWdSSIoDuNz
            AYFREc3wi/a7qy3E11Tp/r+/9KbVJ5GvR5suWkIGv4IO4kV9Zj4X9L/3HtebyIw2m/7Or7q86lnOZxV/7nN3Mbvd9YfYzcfO/sv9M+y69BBoz3X6Z9ixWCwW6xVKylE5X1cbUDUpFzH3xFYpWbeQ8iTJ133XhY1u2zfslYopnXc6GkGkznt3dG5sYJGe+dxjKcFMikot/SWRSyhqQ9BK5/RciCnmZdAJGzpY3U9FQkohwjgLyTvqIpaU7ImQYTZG+RXbW7HKvAgNISbS0ok/Csy2qD+0L3VGj5wyfnSkykETCZOxce8EdESnXFzHscQUlAOsRkXUgX8jxY5S9eRUIHbx
            YHDdbsYxfdw8zWJPJ70Ddp7OSYbsEmXBasZiX3NVdGRG3zLC2RlgwjqdRhGgNIndZYwzMRLxpWJHOQEtlaINqzMv1m8gSMSbGHaYiMzDXKqy9eILf37lJt2fNbouCJFJpCMxc1ZDyGWM2dnS7GopN9hh7p4I3TQbpZlOkQpzNsZ5qtlZLQl/B2FyOO6fyoKmqlE9y3TGXWuRhWfALqt3shZ+iW2xxS5RfncnRSPQSe/AZ1uYt23FDpxWdmRYt/ZUAyE3vxi4pPynpFGY3SO7+1Eo8kSEA83Oi6+vz+rgYldIB7E1dYpUKe/KiNaws+qht8/JA5+zk9+xSwMhIthxNBbSx
            NmQ4mzZpJptZypaSFjZOlmYWqvMWs3Y+7W3Fz60BqtxktIsNO/g0fRFdhbM2zSTmMxTsaOn3x10tRjiSFHALoTeu0J2uH4GmbH5zPqeqaAcp6hRu4HOthosZbIjdlM5u4RgrNnFcZ6bbbQGaZIZY0TFNJ+eMRKJ7Je+KvzBFZpZFYcQOAuhMxpjmjvYbxC7dhjHMDc7W3EW9VXqbIseRQtih9kaN9nt/IXNT6A2OB7SWmbkgFMZX+FsDGSMwyZ2ZXSsxvfsINbKMn4TvaxyrCp2eNI4EHbWLIvFFHbI6hSQhDIWrU4LEHm5Zoex1bO+Z9c2abRhmaRE0GoXnGYHw876KrIs
            k5k+OTVmunqHx1s4bSwofeKCzvQ55VU0N2ahMP9NhcgEPguYmfavqj2iG/dZ0XLWnNYb62rrsrVUj0mSNIUoEKUp/o8B9ymwS+/vdb/Gumjd36cB/FDHuSi918G6SO/NlofFYrFYLBaLxWKxWCwWi8VisVgsFovFYrFYLBaLxWKxWCwWi8Visd5N/wcnsUvRi+w4KAAAAABJRU5ErkJggg==`
            doc.addImage(img, 'PNG', 15, 15, 30, 20);    
            // Add the main Gate Pass header
            doc.setFont("helvetica", "bold");
            doc.setFontSize(14);
            doc.setTextColor(...denimBlue); // Set header text color to denim blue
            doc.text("ARABIAN PIPECOATING CO., LTD.", 70, 25);
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(12);
            doc.text("GATE PASS", 95, 35);

            // Reset text color to black for the rest of the document
            doc.setTextColor(0, 0, 0);

            // Add the Gate Pass number
            doc.setFont("helvetica", "normal");
            doc.setFontSize(10);
            doc.text(`No. ${requestNumber}`, 160, 35);

            // Add a line under the header
            doc.line(10, 40, 200, 40); // Horizontal line

            // Add the first section (Company name, Vehicle No, License No, Driver's Name)

            doc.setFontSize(10);
            doc.text("COMPANY NAME:", 15, 50);
            doc.text(companyName, 60, 50);
            doc.setLineWidth(0.05);
            drawDottedLine(doc, 60, 53, 200, 53, 3, 2);

            doc.text("VEHICLE NO.:", 15, 60);
            doc.text(vehicleNo, 60, 60);
            drawDottedLine(doc, 60, 63, 200, 63, 3, 2);

            doc.text("DRIVER'S NAME:", 15, 70);
            doc.text(driverName, 60, 70);
            drawDottedLine(doc, 60, 73, 200, 73, 3, 2);

            doc.text("LICENSE NO:", 15, 80);
            doc.text(licenseNo, 60, 80);
            drawDottedLine(doc, 60, 83, 200, 83, 3, 2);

            // Add Equipment Section
            doc.text("EQUIPMENT:", 15, 90);
            doc.setLineWidth(0.5);
            // Draw a box for equipment details
            doc.rect(15, 95, 180, 50); // x, y, width, height
            doc.text(equipment, 20, 100, { maxWidth: 170, lineHeightFactor: 1.5 });

            // Add "FROM" and "TO" sections
            doc.text("FROM:", 15, 160);
            doc.text(fromLocation, 60, 160);
            doc.setLineWidth(0.05);
            drawDottedLine(doc, 60, 163, 200, 163, 3, 2);

            doc.text("TO:", 15, 170);
            doc.text(toLocation, 60, 170);
            doc.setLineWidth(0.05);
            drawDottedLine(doc, 60, 173, 200, 173, 3, 2);

            // Add a section for "MANAGEMENT" with a signature box
            doc.text("MANAGEMENT:", 15, 190);
            doc.rect(60, 185, 60, 20); // Box for signature
            

            // Render the PDF
            if (type === "print") {
                doc.autoPrint();
                window.open(doc.output("bloburl"), `Gate Pass`);
                this.setState({ loading: false });
            } else if (type === "download") {
                doc.save(`Gate Pass(${requestNumber}).pdf`);
                this.setState({ loading: false });
            } else if (type === "upload" && requestNumber) {
                let pdf = btoa(doc.output());
                let FileName = requestNumber;
                let Folder = "GatePass";
                let Attachment = pdf;
                let MailData = {
                    FileName,
                    Folder,
                    Attachment,
                };

                let dd = JSON.stringify(MailData);
                let datas = { Key: dd };
                return JSON.stringify(datas);
            }

        }

    saveRequest = (submitType) => {
        const { containerData } = this.props;
        const { process } = this.state;
        const type = this.props.match.params.type;
        let requestNumber = (this.props.location && this.props.location.state && this.props.location.state.requestNum) || '';
        let loggedUserEmpId = this.props.loggedUserDetail.empID;


        let RequestAttributes = [];
        let Comment = '';
        process.map((stage, stageIndex) => {
            stage.stage_Field.map(el => {

        //         if (el.fieldDescription === 'Comment' && stageIndex === 0) {
        //             Comment = el.fieldValue;
        //         }
        //         if(el.fieldDescription === 'Expense Type' && stageIndex === 0){
        //             RequestType = el.fieldValue;
        //         }

                RequestAttributes.push(Object.assign({}, { ...el }, { fieldValue: (el.fieldType === "7" || el.fieldType === "8") ? moment(el.fieldValue).format('MM/DD/YYYY') : el.fieldValue }));
            })
        });

        // if(!RequestType){
        //     this.growl.show({ severity: 'error', summary: null, detail: 'Please choose Expense Type before Submitting/Saving' });
        //     return;
        // }


        let data = {
            FromDate: moment().format('MM/DD/YYYY'),
            ToDate: moment().format('MM/DD/YYYY'),
            VisaCount: 0,
            TicketCount: 0,
            RequestDesc: 'Material Pass Vehicle Request',
            IsActive: true,
            RequestDate: moment().format('MM/DD/YYYY'),
            EmpID: this.props.loggedUserDetail.empID,
            LoginEmployeeID: this.props.loggedUserDetail.empID,
            CompanyID: this.props.loggedUserDetail.CompanyId,
            Remark: Comment,
            RequestedFor: this.props.loggedUserDetail.empID,
            ProcessID: MATERIAL_PASS_VEHICLE_ID,
            RequestAttributes: RequestAttributes,
            Requestattachments: this.state.requestattachments,
            Requestforms: [],
            Requestactions: [],
            stagesequence: this.state.stageSequence,
            processNum: containerData.processNum
        };


        if (process && process.length > 0) {

            let model = 'requestSave';
            if (submitType === 'submit') {
                if (this.state.DynamicSupervisor) {
                    data.DynamicSupervisor = this.state.DynamicSupervisor;
                }

                model = 'GatePassMaterial';
            }

            if (submitType === 'delegate') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Delegate_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'GatePassMaterial';
            }

            if (submitType === 'forward') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Forward_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'GatePassMaterial';
            }

            if (submitType === 'return' && this.state.DynamicSupervisor) {
                const SelDropdownEmployee = this.state.DynamicSupervisorsList.find(el => el.value === this.state.DynamicSupervisor);
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Return_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                data.Return_to_WF_Level_ID = SelDropdownEmployee && Object.keys(SelDropdownEmployee).length > 0 && SelDropdownEmployee.Request_WF_LEVEL_ID;
            }


            if (this.state.requestId) {
                data.requestId = this.state.requestId
            }

            var stringifyData = JSON.stringify(data);
            var datas = { Key: stringifyData };

            let url = (type === 'edit') ? '/master/api/UpdateDynamicData?model=' + model : '/master/api/InsertDynamicData?model=' + model;

            if (submitType === 'submit') {
                url = '/master/api/workflow/submit?type=' + model;
            } else if (submitType === 'reject') {
                url = '/master/api/workflow/reject?type=' + model;
            } else if (submitType === 'delegate') {
                url = '/master/api/workflow/delegate?type=' + model;
            } else if (submitType === 'forward') {
                url = '/master/api/workflow/forward?type=' + model;
            } else if (submitType === 'return') {
                url = '/master/api/workflow/return?type=' + model;
            } else if (submitType === 'cancel') {
                url = '/master/api/workflow/cancel?type=' + model;
            }

            this.setState({ loading: true });

            if(requestNumber && submitType == 'submit'){//checking whether the request is in the requester stage or approver stage
                let generatedPdf = this.handlePayslipInPdf('upload', loggedUserEmpId.toUpperCase());
                axios.post(`/master/api/Base4ToPDF`, generatedPdf)
                    .then(response => {
                        if(response.status == 200){
                            axios.post(url, JSON.stringify(datas))// triggering the submit/save of a request
                                .then(response => {
                                    this.setState({ loading: false });
                                    if (submitType === 'submit' || submitType === 'return') {
                                        if (response.status === 200) {
                                            if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
                                                let submitValue = response.data.result && JSON.parse(response.data.result);
                                                let tableValue = [];
                                                if (submitValue.Table && submitValue.Table !== undefined && submitValue.Table.length > 0) {
                                                    tableValue = submitValue.Table.map(list => {
                                                        return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO ,Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID}
                                                    })
                                                }
                                                if(submitType === 'submit'){
                                                    this.setState({dialogBoxText: "Select Supervisor"})
                                                }
                                                if(submitType === 'return'){
                                                    this.setState({dialogBoxText: "Return To", popupType:'return'})
                                                }
                                                this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
                                            } else {
                                                this.growl.show({ severity: 'success', summary: null, detail: 'Material Pass In Request submitted successfully' });
                                                this.props.history.push('/dashboard');
                                            }
                                        } else {
                                            this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                                        }

                                    } else {
                                        this.growl.show({ severity: 'success', summary: null, detail: 'Material Pass In Request saved successfully' });
                                        this.props.history.push('/dashboard');
                                    }

                                })
                                .catch(err => {
                                    this.setState({ loading: false })
                                    this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                                })
                        }
    
                    }).catch(err => {
                        this.growl.show({ severity: 'error', summary: null, detail: 'File Upload API Failed. Please Approve again' });
                        this.setState({ loading: false });
                    })
            } else {
            axios.post(url, JSON.stringify(datas))
                .then(response => {

                    this.setState({ loading: false });
                    if (submitType === 'submit' || submitType === 'return') {
                        if (response.status === 200) {
                            if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
                                let submitValue = response.data.result && JSON.parse(response.data.result);
                                let tableValue = [];
                                if (submitValue.Table && submitValue.Table !== undefined && submitValue.Table.length > 0) {
                                    tableValue = submitValue.Table.map(list => {
                                        return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO ,Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID}
                                    })
                                }
                                if(submitType === 'submit'){
                                    this.setState({dialogBoxText: "Select Supervisor"})
                                }
                                if(submitType === 'return'){
                                    this.setState({dialogBoxText: "Return To", popupType:'return'})
                                }
                                this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
                            } else {
                                this.growl.show({ severity: 'success', summary: null, detail: 'Material Pass Vehicle Request submitted successfully' });
                                this.props.history.push('/dashboard');
                            }
                        } else {
                            this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                        }

                    } else {
                        this.growl.show({ severity: 'success', summary: null, detail: 'Material Pass Vehicle Request saved successfully' });
                        this.props.history.push('/dashboard');
                    }

                })
                .catch(err => {
                    this.setState({ loading: false })
                    this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                })
            }

        }

    }

    componentDidMount() {
       const { getContainerData, getKeywordValues, getMasterKeywordList, location = {}, loggedUserDetail } = this.props;
        const type = this.props.match.params.type;
        // this.effectiveDateHandler()
        getContainerData(MATERIAL_PASS_VEHICLE_ID);//Get Container Data
        getKeywordValues('Employee');//Get Employee Dropdown list

        getMasterKeywordList('Employee');//Get Employee 
        getMasterKeywordList('nationality');//Get Nationality Dropdown list 
        // this.getCurrencyList()

        if (type === 'edit') {
            this.props.getRequestAttributeData(this.props.match.params.id);
        }

        const clearTimer = () => clearInterval(interval);
        const interval = setInterval(() => {
            const stageSequence = (location.state && location.state.stagesequence) || this.state.stageSequence;
            const requestId = this.props.match.params.id || this.state.requestId;
            const { tableLists, containerData } = this.props;
            const type = this.props.match.params.type;
            let requestattachments = tableLists.requestattachments || [];
            this.setState({requestattachments});

            const container = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            let process = containerData && Object.keys(containerData).length > 0 && containerData.stage || false;
            if (type === 'edit') {
                process = tableLists && Object.keys(tableLists).length > 0 && tableLists.requestAttribute1 || false;
            }

            if (process && !this.props.loading) {
                this.setState({ stageSequence, requestId, initialData: type === 'edit' && process.length > 0 && process.concat(container.filter(((c, i) => i > (process.length - 1)))) || process });
                setTimeout(() => this.initialize(type === 'edit' && process.length > 0 && process.concat(container.filter(((c, i) => i > (process.length - 1)))) || process, type === 'edit' ? 'edit' : 'add'), 3000);
                clearTimer();
            }
        }, 300); 

    }


    render() {
        const { tableLists, location = {}, metaData = {} } = this.props;
        const { state = {} } = location;
        const { process, stageSequence, currentSequence, editing } = this.state;
        const pendingWith = location && location.state && location.state.pendingWith;

        const pageType = this.props.match.params.type;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;  
        const dialogDynamicFooter = (
            <div>
                <Button icon="pi pi-times" onClick={() => this.setState({ dynamicSupervisorDisplay: false, DynamicSupervisor: null, DynamicSupervisorsList: null })} label="Close" className="p-button-secondary" />
                <Button onClick={() => this.saveRequest(this.state.popupType || 'submit')} icon="pi pi-check" disabled={(this.state.DynamicSupervisor === null)} label="Submit" className="p-button-primary  ml1" />
            </div>
        );
        let a;
        {
            a = process.filter((p, i) => i <= parseInt(stageSequence));
       }


        return (
            <div className="p-grid leaverequest">
                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                {(this.props.error !== null || this.state.error) && <Messages type="error" message={this.props.error || this.state.error} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>
                        Vehicle GatePass Request
                            <Link to={'/materialpass-vehicle'}>
                                <Button style={{ float: 'right' }} label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" />
                            </Link>
                        </h1>
                        <UserInfo userObject={this.props.userPosInfo} requestNum={state.requestNum} />
                    </div>
                </div>
                

                
                {process.filter((p, i) => i <= parseInt(stageSequence)).map((stage, stageIndex) => {
                    const { stage_Field, description } = stage;
                    const stageField = arraySort(stage_Field, 'fieldSequence');
                    
                    return <div key={stageIndex} className="p-col-12">
                        <div className="card card-w-title">
                            <h1>{description}</h1>
                            <div className="p-grid">
                                {(stageField || []).map((field, fieldIndex) => {
                                    const containerGroup = field.fieldType === '9' && lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr')) || false;
                                    const containerFields = (containerGroup && Object.keys(containerGroup).length > 0 && editing && editing.parentFieldId === field.fieldName && containerGroup[editing.childRowNmbr]) || (containerGroup && Object.keys(containerGroup).length > 0 && containerGroup[Object.keys(containerGroup).length - 1]) || [];
                                    const containerTable = containerGroup && Object.keys(containerGroup).length > 0 && Object.keys(containerGroup).filter((g, i) => i != Object.keys(containerGroup).length - 1).reduce((tableRow, row) => {
                                        const rowFields = containerGroup[row].reduce((r, c) => {
                                            const DropdownValues = metaData[c.fieldDescription] && c.fieldValue && metaData[c.fieldDescription].find(_ => _.value === c.fieldValue) || false;
                                            return Object.assign({}, { ...r }, { [c.fieldDescription.replaceAll(' ', '_')]: (DropdownValues && DropdownValues.label) || ((c.fieldType === '7' || c.fieldType === '8') && moment(c.fieldValue).format('MM/DD/YYYY')) || c.fieldValue, childRowNmbr: c.childRowNmbr, parentFieldId: c.parentFieldId })
                                        }, {});
                                        tableRow.push(rowFields);
                                        return tableRow;
                                    }, []) || [];
                                   
                                    return field.parentFieldId === "000" ? <div key={fieldIndex} className={field.fieldType === "9" || field.fieldType === "6" ? "p-col-12" : "p-col-12 p-md-6 p-lg-4"}>
                                        {field.fieldType != "9" ? <Inputs
                                            field={field}
                                            value={field.fieldType === '3' && field.fieldValue ? field.fieldValue.split(",") : field.fieldValue}
                                            process={process}
                                            onInputChange={(e) => this.handleChange(e, field)}
                                            {...this.props}
                                            {...this.state} /> :
                                            field.fieldType === '9' ?
                                                <Fieldset legend={field.fieldDescription} toggleable collapsed={this.state[field.fieldName] === undefined ? true : this.state[field.fieldName]} onToggle={(e) => this.setState({[field.fieldName]: e.value})} style={{border: this.state[field.fieldName] === undefined || this.state[field.fieldName] ? 'none' : '1px solid rgba(0, 0, 0, 0.38)'}}>
                                                    <div className="p-grid">
                                                        {containerFields.map((subField, subIndex) => <div key={subIndex} className={"p-col-12 p-md-6 p-lg-4"}><Inputs
                                                            field={subField}
                                                            value={subField.fieldType === '3' && subField.fieldValue ? subField.fieldValue.split(",") : subField.fieldValue}
                                                            process={process}
                                                            onInputChange={(e) => this.handleChange(e, subField)}
                                                            {...this.props}
                                                            {...this.state} /></div>)}
                                                        <div className="p-col-12 p-md-6 p-lg-4">
                                                            {editing && editing.parentFieldId === field.fieldName ? <div className="mt2" style={{ padding: '8px' }}>
                                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" icon="pi pi-pencil" onClick={() => this.setState({ editing: false })} label="Update" style={{ marginRight: '10px' }} />
                                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" onClick={() => this.setState({ editing: false })} label="Cancel" />
                                                            </div> : <div className="mt2" style={{ padding: '8px' }}>
                                                                    <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" icon="pi pi-plus" onClick={() => this.handleContainer(field)} label="Add" />
                                                                </div>}
                                                        </div>
                                                        <div className="p-col-12">
                                                            <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true}
                                                            expandableRowGroups={false} expandedRows={this.state.expandedRows} onRowToggle={(e) => { this.setState({ expandedRows: e.data }) }}
                                                            rowExpansionTemplate={this.rowExpansionTemplate} 
                                                            dataKey="childRowNmbr" rows={10} value={containerTable}>
                                                            <Column expander={true} style={{ width: '3em' }} />
                                                                {containerFields.map((columnField, columnIndex) =>
                                                                    (pageType == 'edit' & columnField.fieldDescription == 'Original Currency') ? <Column key={columnIndex} field={columnField.fieldDescription.replace(' ', '_')} header={columnField.fieldDescription} body={this.currencyNameRender} /> : <Column key={columnIndex} field={columnField.fieldDescription.replace(' ', '_')} header={columnField.fieldDescription} /> 
                                                                    )}
                                                                {
                                                                    ((pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null)) ? null : <Column body={this.actionTemplate} header="Action" style={{ textAlign: 'center', width: '8em' }} />
                                                                }
                                                            </DataTable>
                                                        </div>
                                                    </div>
                                                </Fieldset> : null}
                                    </div> : null

                                })}


                                {( stage.stageNum == '000' || stage.stageSequence == 0)  ? 
                                <div className="p-col-12 p-md-12 p-lg-12">
                                     <Attachments 
                                     handleAttachment = {this.handleAttachment} 
                                     folderName = 'VehiclePass'
                                     reloadedValues = {this.state.requestattachments}
                                     isReloaded = {(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false}
                                     /> 
                                </div> 
                                    :
                                 null}
 
                                {stageIndex > 0 ?
                                    <div className="p-col-12 p-md-12 p-lg-12" >
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success ml1" label="Approve" icon="pi pi-save" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Reject" onClick={() => this.saveRequest('reject')} className="p-button-danger ml1" />
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Return" onClick={() => this.saveRequest('return')} className="p-button-warning ml1" /> */}
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Forward" onClick={() => this.handleMethods('forward')} className="ml1" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Delegate" onClick={() => this.handleMethods('delegate')} className="p-button-info ml1" /> */}
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" /> */}
                                        <Link to={'/materialpass-vehicle'}>
                                            <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div> :
                                    
                                    <div className="p-col-12 p-md-12 p-lg-12" >
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success ml1" label="Submit" icon="pi pi-save" />
                                        <Button disabled={status && status === 'Closed' && pendingWith === 'Closed' ? false : true} className="p-button-danger ml1" label="Cancel" style={{ marginRight: '10px' }} onClick={() => this.saveRequest('cancel')} />
                                        {/* <Button onClick={() => this.generatePayslip('view')} className="p-button-success ml1" label="View Payslip" icon="pi pi-save" /> */}
                                        {/* <Button /*disabled={this.state.payslipGenerated == false? true : false} onClick={() => this.setState({ payslipDisplay: true})} className="p-button-success ml1" label="View Payslip" icon="pi pi-save" /> */}{((status && status === 'Closed') && (pendingWith && pendingWith === 'Closed')) ? <Button /*disabled={this.state.payslipGenerated == false? true : false}*/ onClick={() => this.generatePayslip('download')} className="p-button-success ml1" label="Download Gatepass as PDF" icon="pi pi-save" /> : null} 
                                        {((status && status === 'Closed') && (pendingWith && pendingWith === 'Closed')) ?
                                        <Button /*disabled={this.state.payslipGenerated == false? true : false}*/ onClick={() => this.generatePayslip('print')} className="p-button-success ml1" label="Print Gatepass" icon="pi pi-save" />: null}
                                        <Link to={'/materialpass-vehicle'}>
                                            <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div>}
                            </div>
                        </div>
                    </div>
                })}


                <Dialog header={this.state.dialogBoxText} visible={this.state.dynamicSupervisorDisplay} modal={true} width="400px" footer={dialogDynamicFooter} onHide={() => this.setState({ dynamicSupervisorDisplay: false })}>
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                            <label className="label">{this.state.dialogBoxText}<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown placeholder={this.state.dialogBoxText} name="DynamicSupervisor" value={this.state.DynamicSupervisor} options={this.state.DynamicSupervisorsList} onChange={(e) => this.setState({ DynamicSupervisor: e.target.value })}   {...DROPDOWN_CONFIG} style={{ width: '100%' }} />
                            </div>
                        </div>
                    </div>
                </Dialog>

            </div>

        );
    }







}

const mapStateToProps = state => {
    const Employee = (state.keyword.Employee !== undefined) ? state.keyword.Employee : [];
    const loggedUserDetail = state.auth.userObject || {};
    const subordinatesListData = state.master.subordinatesListData;
    const keywordValuesList = state.master.keywordValuesList.reduce((a, el) => {
        if (el.uniqueId !== state.auth.userObject.empID) {
            a.push(Object.assign({}, { ...el }, { value: el.uniqueId }));
        }
        return a;
    }, [Object.assign({}, state.master.keywordValuesList.find(list => list.uniqueId === state.auth.userObject.empID), { label: `${state.auth.userObject.userName}-Self`, value: state.auth.userObject.empID, id: parseInt(state.auth.userObject.userID) })]);

    let relevantOptions = [];
    const hrTeam = parseInt(localStorage.getItem('hrTeam'));
    if (hrTeam) {
        relevantOptions = Employee.reduce((a, el) => {
            if (el.value !== loggedUserDetail.empID) {
                a.push(el);
            }
            return a;
        }, [Object.assign({}, Employee.find(list => list.value === loggedUserDetail.empID), { label: 'Self', id: loggedUserDetail.userID })]);
    } else {
        relevantOptions = (loggedUserDetail !== null) ? [{ label: `${loggedUserDetail.userName}(Self)`, value: loggedUserDetail.empID, id: loggedUserDetail.userID }].concat(subordinatesListData) : subordinatesListData;
    }
    return {
        loggedUserDetail,
        userPref: state.auth.userPref,
        userPosInfo: state.auth.userPosInfo,
        loading: state.master.loading || state.keyword.loading,
        error: state.master.error || state.keyword.error,
        containerData: state.master.containerData,
        tableLists: state.master.requestAttributeData,
        subordinatesListData,
        Employee,
        EmployeeList: relevantOptions,
        // currencyList: currencyList && currencyList || [],
        keywordValuesList,
        metaData: Object.assign({}, {
            "Requested For": relevantOptions,
            "Nationality": state.keyword.nationality,
        })
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getContainerData: (process_Id) => dispatch(actions.getContainerData(process_Id)),
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        getKeywordValues: (value) => dispatch(actions.getKeywordValues(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
        getRequestAttributeData: (id) => dispatch(actions.getRequestAttributeData(id)),
        clearCacheStorage: (type, data) => dispatch(actions.clearCacheStorage(type, data))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddMaterialPassVehicle);